import React from 'react';
import Sorting from '../../views/Sorting';
import Cookies from 'js-cookie';
import '../../css/regokas.css';
import _ from 'lodash';
import Loader from '../../components/loader';
import Edit from '../../images/headericon/Edit.svg';
import Delete from '../../images/headericon/Delete.svg';
import Success from '../../images/Success.svg';
import Error from '../../images/Error.svg';
import Delete1 from '../../images/headericon/deletedeactive.svg';
import errorText from '../../errorText';
import SearchBar from '../../views/SearchBar';
// import windowSize from 'react-window-size';
import Style from 'style-it';
import IntegrationReactSelectNew from '../../views/IntegrationReactSelectNew';
import { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// import {
//     Input,
//     MDBSelect,
//     MDBSelectInput,
//     MDBSelectOptions,
//     MDBSelectOption
// } from 'mdbreact';

import { connect } from 'react-redux';
import * as ActionTypes from '../../actions/types';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { AiOutlinePlus } from 'react-icons/ai';


class AssignOkasBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            okasInventoryData: [],
            okasBoxDatalocation: [],
            siData: [],
            kk: 'asdvhj',
            okasBox_type: '',
            okasBox_serialNo: '',
            okasBox_version: '',
            user: '',
            created_at: '',
            selectedBoxes: [],
            // selectedSi: [],
            selectedSi: '',
            si_id: '',
            okasBox_id: [],

            error: '',
            nameerror: '',
            namess: '',
            sortedType: '',
            searchValue: '',
            actualdata: [],
            disabledvalue: '',
            successmsgmodaldata: localStorage.getItem('dataadded'),
            usertype: localStorage.getItem('usertype'),
            showmodels: '',
            showmodels1: '',
            loader: '',
            passwordi: false,
            currentPage: 1,
            todosPerPage: 10,
            statuson: false, statustw: false, statusth: false,
            statusfo: false, statusfi: false, statussi: false,
            statusse: false, statusei: false, statusni: false,
            statuste: false,
            disableAddButton: false,
            confirmWindow: false,
            projectManagerToDelete: '',
            pagemode: ''

        };
        this.handleClickpage = this.handleClickpage.bind(this);
    }

    state = {
        checkedA: true,
        checkedB: true,
        checkedF: true,
    };
    handleChange12 = name => event => {
        this.setState({ [name]: event.target.checked });
    };



    crosserrorfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            error: '',
        })

    }

    // confirmWindowClose = () => {
    //     this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);

    //     this.setState({
    //         confirmWindow: false
    //     })
    // }

    // oncolseClickHandler = (event) => {
    //     this.setState({
    //         si_name: '',
    //         si_mobile: '',
    //         si_email: '',
    //         si_company: '',
    //         si_address: '',
    //         si_area: '',
    //         si_description: '',
    //         si_rating: '',
    //         si_relationstatus: '',
    //         si_gstin: '',
    //         si_type: '',
    //     })
    //     this.onclosemodel1()
    // }

    componentWillMount() {
    }

    errormsg = () => {
        setTimeout(
            function () {
                localStorage.removeItem('dataadded');
                this.setState({
                    successmsgmodaldata: '',
                    error: '',
                })
            }
                .bind(this), 3000
        );
    }

    crosssuccessfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            successmsgmodaldata: '',
        })
    }

    componentDidMount() {
        this.getallrealdata();
    }

    getallrealdata = () => {
        this.setState({
            loader: true,
        })
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        fetch('/we/we/okastabledata', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(okasInventoryData => {
                this.setState({
                    okasInventoryData,
                    actualdata: okasInventoryData
                }, () => {
                    this.renderTableData();
                })
                this.setState({
                    loader: false,
                })
            })

        fetch('/we/we/addSI/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(siData => {
                this.setState({
                    siData,
                    actualdata: siData
                }, () => {
                    this.renderTableData();
                    // console.log('asData',this.state.actualdata)
                })
                this.setState({
                    loader: false,
                })
            })

    }



    renderTableDatalocation = (type) => {
        if (type === 'location') {
            var typee = 0;
            let xx = this.state.okasBoxDatalocation.map((e, index) => {
                // console.log(e)
                typee = typee + 1;
                return (
                    <option key={index} value={e.ID}>{e.location}</option>
                )
            });
            return xx;
        }
    }

    renderLocation = () => {
        let LocationData = [];
        if (Array.isArray(this.state.okasBoxDatalocation)) {
            this.state.okasBoxDatalocation.forEach((e) => {
                LocationData.push({
                    label: e.location,
                    value: e.ID.toString()
                });
            });
            this.setState({
                LocationData: LocationData
            });

        } else {
            return null;
        }
    }


    handleClickpage(event) {
        this.setState({
            currentPage: Number(event.target.id)
        });
        this.renderTableData('type1');
        this.renderTableData('pagination');

    }

    handleCheckboxChange = (boxId) => {
        const { selectedBoxes } = this.state;
        const index = selectedBoxes.indexOf(boxId);

        if (index === -1) {
            this.setState((prevState) => ({
                selectedBoxes: [...prevState.selectedBoxes, boxId],
                okasBox_id: [...prevState.okasBox_id, boxId],
            }));
        } else {
            const updatedSelectedBoxes = [...selectedBoxes];
            updatedSelectedBoxes.splice(index, 1);

            this.setState({
                selectedBoxes: updatedSelectedBoxes,
                okasBox_id: updatedSelectedBoxes,
            });
        }
    };

    handleRadioSiChange = (siId) => {
        this.setState({
            selectedSi: siId,
            si_id: siId,
        });
    };

    // handleRadioSiChange = (siId) => {
    //     const { selectedSi } = this.state;
    //     const index = selectedSi.indexOf(siId);

    //     if (index === -1) {
    //       this.setState((prevState) => ({
    //         selectedSi: [...prevState.selectedSi, siId],
    //       }), () => {
    //         console.log("selected", this.state.selectedSi);
    //       });
    //     } else {
    //       const updatedSelectedBoxes = [...selectedSi];
    //       updatedSelectedBoxes.splice(index, 1);

    //       this.setState({
    //         selectedSi: updatedSelectedBoxes,
    //       }, () => {
    //         console.log("updated", this.state.selectedSi);
    //       });
    //     }
    // };

    renderTableData = (type) => {
        if (this.state.okasInventoryData.detail == 'Invalid token.') {
            localStorage.removeItem('auth');
            localStorage.removeItem('username');
            this.props.history.push('/login')
        }

        let indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
        let indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
        let currentTodos = this.state.okasInventoryData.slice(indexOfFirstTodo, indexOfLastTodo);
        let currentSi = this.state.siData.si_data;


        if (type === 'pagination') {
            let pageNumbers = [];
            for (let i = 1; i <= Math.ceil(this.state.okasInventoryData.length / this.state.todosPerPage); i++) {
                pageNumbers.push(i);
            }
            let renderPageNumbers = pageNumbers.map((number, i) => {
                if ((this.state.currentPage - 3 < i + 1) && ((this.state.currentPage + 3 > i + 1 || 6 > i + 1))) {
                    return (
                        <li className={this.state.currentPage == number ? "active" : null}><a id={number} onClick={this.handleClickpage}>{number}</a></li>
                    );
                }
            });
            return renderPageNumbers;
        }

        if (type === 'type1') {
            var typee = 0;
            let xx = currentTodos.map((e, index) => {
                typee = typee + 1;
                return (
                    <tr key={index}>
                        <td className={this.props.windowWidth > 760 ? "qwerty" : ""}>
                            <input
                                type="checkbox"
                                name={e.okasBox_type}
                                onChange={() => this.handleCheckboxChange(e.okasBox_id)}
                                disabled={e.user !== "unassigned"}
                                checked={this.state.selectedBoxes.includes(e.okasBox_id)}
                            />
                        </td>
                        <td className={this.props.windowWidth > 760 ? "qwerty" : ""}>{(this.state.currentPage * this.state.todosPerPage) - this.state.todosPerPage + index + 1}</td>
                        <td>{e.okasBox_type}</td>
                        <td >{e.okasBox_serialNo}</td>
                        <td>{e.okasBox_version}</td>
                        <td>{e.user === "unassigned" ? <span style={{ color: "red" }}>UNASSIGNED</span> : <span style={{ color: "green" }}>ASSIGNED</span>}</td>
                        <td>{e.created_at.substring(0, 10) + ' ' + e.created_at.substring(11, 19)}</td>

                    </tr>
                )
            });
            return xx;
        }

        if (type === 'siSelect') {
            var typee = 0;
            let xx = currentSi.map((e, index) => {
                typee = typee + 1;
                return (
                    <tr key={index}>
                        <td className="config-table">{e.si_name}</td>
                        <td className="config-table">{e.si_area}</td>
                        <td className="config-table">{e.si_mobile}</td>
                        {/* <td className="config-table">{e.si_email}</td> */}
                        <td className="config-table">
                            <input
                                type="radio"
                                name={e.si_name}
                                checked={this.state.selectedSi === e.si_id}
                                onChange={() => this.handleRadioSiChange(e.si_id)}
                            />
                        </td>
                    </tr>
                )
            });
            return xx;
        }
    }



    onopenmodel = (event) => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);

        this.setState({
            showmodels: 'true',
            pagemode: ''
        });
        const selectedBoxIds = this.state.selectedBoxes.join(', ');
        const modalTitle = selectedBoxIds ? `Assign Box ${selectedBoxIds} to` : 'Assign Box';

        this.setState({
            modalTitle: modalTitle,
        });
        this.props.searchBarActivate(false)
    }

    onclosemodel = (event) => {
        this.setState({
            showmodels: '',
        })
    }

    onAssignSiClosemodel = (event) => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
        this.setState({
            showmodels: '',
            si_id: '',
            okasBox_id: [],
            disableAddButton: false,
            selectedBoxes: [],
            selectedSi: '',
        })
    }


    onAddClickHandler = (buttonaction) => {

        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken'),
        }

        const { si_id, okasBox_id } = this.state;

        let tt = {
            si_id: si_id,
            okasBox_id: okasBox_id,
        };

        if (si_id && okasBox_id) {
            this.setState({ disabledvalue: 'disabled' });
            this.setState({ loader: true });

            fetch('/we/we/assignSI/ ', {
                method: "POST",
                headers: headers,
                body: JSON.stringify(tt)
            })
                .then(response => response.json())
                .then(data => {
                    if (data.message === "Success" && buttonaction === 'add') {
                        this.setState({
                            successmsgmodaldata: 'dataadded',
                            successmodalstates: 'add',
                            disabledvalue: '',
                        });
                        this.getallrealdata();
                        alert('Box Successfully Assign To System Integrator!');
                        this.onAssignSiClosemodel();
                        this.errormsg();
                        //   if (buttonaction === 'add') {
                        //     this.onAssignSiClosemodel();
                        //   }

                    } else {
                        this.setState({ disabledvalue: '' });
                        this.setState({ loader: false });
                        alert("Unable To Assign System Integrator")
                        return null;

                    }
                    this.setState({
                        loader: false,
                    });
                })
        }
    }


    restoreData = (data) => {
        this.setState({
            okasInventoryData: data,
        })
    }


    sortingFunc = (type, searchValue) => {


        if (type !== "search") {
            this.props.searchBarActivate(false)
        }

        if (type == "okasBox_type") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statuson: !this.state.statuson,
            })
        }
        if (type == "okasBox_serialNo") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statuson: !this.state.statuson,
            })
        }
        if (type == "okasBox_version") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statustw: !this.state.statustw,
            })
        }
        if (type == "user") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statusth: !this.state.statusth,
            })
        }
        if (type == "created_at") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statusth: !this.state.statusth,
            })
        }


        if (this.state.sortedType !== type && type !== 'search') {
            this.setState({
                sortedType: type
            })
            Sorting(this.restoreData, type, this.state.okasInventoryData);
        } else if (type === 'search') {
            type = 'search';
            Sorting(this.restoreData, type, this.state.actualdata, searchValue);
        } else {
            type = 'reverse';
            Sorting(this.restoreData, type, this.state.okasInventoryData);
        }
    }




    // onSearchClick = () => {
    //     this.props.searchBarActivate(!this.props.redux.globalVar.searchBarShow)
    // }

    onSelectChange = (operationMode, valueSelect) => {
        if (valueSelect.label !== undefined) {
            this.setState({
                [operationMode]: valueSelect.value,
                error: false,
                locationerror: false,
            })

        }
    }


    render() {
        return Style.it(`
        @media only screen and (max-width: 760px){
      td:nth-of-type(1):before { content: ""; }
      td:nth-of-type(2):before { content: "S.NO"; }
      td:nth-of-type(3):before { content: "BOX TYPE"; }
      td:nth-of-type(4):before { content: "SERIAL NO."; }
      td:nth-of-type(5):before { content: "BOX VERSION"; }
      td:nth-of-type(6):before { content: "STATUS"; }
      td:nth-of-type(7):before { content: "DATE OF PURCHASE"; }

      td.config-table:nth-of-type(1):before { content: "System Integrator Name"; }
      td.config-table:nth-of-type(2):before { content: "Area"; }
      td.config-table:nth-of-type(3):before { content: "Mobile No"; }
      td.config-table:nth-of-type(4):before { content: " "; }
    }`, <div>
            <ToastContainer />
            <div className="selfcontainer"
                style={{
                    position: !this.props.redux.globalVar.backgroundScrollStop && this.props.windowWidth < 760 ? "fixed" : "absolute",
                    overflow: !this.props.redux.globalVar.backgroundScrollStop && this.props.windowWidth < 760 ? "hidden" : "",

                }}

            >
                <ToastContainer />
                {this.state.loader ? <Loader /> : null}

                {this.props.redux.globalVar.searchBarShow ?
                    <div className='row searchinput'>
                        <SearchBar
                            autoFocus
                            value={this.state.searchValue}
                            onChange={(e) => {
                                this.setState({
                                    searchValue: e
                                }, () => {
                                    this.sortingFunc('search', this.state.searchValue)
                                })
                            }
                            }
                            onRequestSearch={() => this.sortingFunc('search', this.state.searchValue)}
                            resetSearch={(e) => {
                                this.setState({
                                    searchValue: e
                                }, () => {
                                    this.sortingFunc('search', '')
                                })
                            }}
                        />
                    </div>
                    : ''}

                {this.state.showmodels ?
                    <div className="selfmodal fade" id="mastercontrollerbox" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                        <div className="selfmodal-dialog"
                            style={{
                                width: this.props.windowWidth > 760 ? "50%" : "95%",

                            }}
                        >
                            <div className="selfmodal-content" style={{ marginTop: "100px" }}>
                                <div className="modal-header" >
                                    <button type="submit" className="close" data-dismiss="modal"
                                        onClick={this.onAssignSiClosemodel.bind(this)}
                                    >&times;</button>
                                    <h3 className="modal-title">{this.state.modalTitle} </h3>
                                </div>
                                <div className="modal-body" >
                                    <table className={this.props.windowWidth > 760 ? "table table-striped tablecontent" : "mobile-device-margin-zero"} id="example" >
                                        <thead >
                                            <tr>
                                                <th>System Integrator Name</th>
                                                <th>Area</th>
                                                <th>Mobile No.</th>
                                                {/* <th>Email</th> */}
                                                <th />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.renderTableData('siSelect')}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="modal-footer">
                                    <React.Fragment>
                                        <button type="button"
                                            onClick={this.onAssignSiClosemodel.bind(this)}
                                            className="btn allbtn" data-dismiss="modal">
                                            Cancel
                                        </button>
                                        <button type="submit" disabled={this.state.disabledvalue ? this.state.disabledvalue : null}
                                            onClick={this.onAddClickHandler.bind(this, 'add')}
                                            className="btn btn-primary allbtn" data-dismiss="modal">
                                            Add
                                        </button>
                                    </React.Fragment>
                                </div>
                            </div>
                        </div>
                    </div>

                    : null}

                <div className="addregOkasButton" >
                    {this.state.selectedBoxes.length > 0 && (
                        <a className="addregOkasButtonicon button-custom-height-size" data-toggle="modal" data-target="#myModal" onClick={this.onopenmodel.bind(this)}>
                            <AiOutlinePlus size={42} style={{ color: " #15599F" }} />
                            <span className="hidden-xs hidden-sm button-color">Assign To System Integrator</span> </a>
                        // <div className="hidden-xs hidden-md  hidden-lg button-color sm-heading-btn">Assign To System Integrator</div>
                    )}
                </div>

                <div className="row">
                    <h3 className="sentence-case">{this.props.redux.globalVar.reUserNameStyle}'s OKAS Box inventory</h3>
                    <h6 className="mb-3 mt-0">Find the comprehensive view and details of all the boxes in your inventory.</h6>
                    {/* <div className={this.state.successmsgmodaldata ? 'successmsgbox' : 'successmsgbox successmsgboxnone'}  >
                        <div className="inblksuccfull"><img src={Success} /></div>
                        <div className="inblksucc1">
                            SUCCESS !
                            <a className="successmsgcross"><Icon icon={cross} size={20} onClick={(e) => { this.crosserrorfullmsg(this) }} /></a>
                        </div>
                    </div> */}

                    <div className="tests" onContextMenu={(e) => { e.preventDefault(); }}>
                        <table className={this.props.windowWidth > 760 ? "table table-striped tablecontent" : "mobile-device-margin-zero"} id="example" >
                            <thead>
                                <tr>
                                    <th></th>
                                    <th className={this.props.windowWidth > 760 ? "qwerty" : ""}
                                        style={{
                                            paddingRight: "24px",
                                            width: this.props.windowWidth > 835 ? "6%" : ""
                                        }}>S.No
                                    </th>
                                    {/* <th style={{ width: this.props.windowWidth > 835 ? "20%" : "20%" }}>BOX TYPE<Icon icon={this.state.statuson ? ic_keyboard_arrow_up : ic_keyboard_arrow_down} size={16} className="pull-right" onClick={(e) => { this.sortingFunc('okasBox_type', '') }} /></th> */}
                                    <th style={{ width: this.props.windowWidth > 835 ? "20%" : "20%" }}>
                                        BOX TYPE
                                        {this.state.statuson ? (
                                            <IoIosArrowUp size={16} className="pull-right" onClick={() => this.sortingFunc("okasBox_type", "")} />
                                        ) : (
                                            <IoIosArrowDown size={16} className="pull-right" onClick={() => this.sortingFunc("okasBox_type", "")} />
                                        )}
                                    </th>
                                    {/* <th style={{ width: this.props.windowWidth > 835 ? "15%" : "15%" }} >SERIAL NO.<Icon icon={this.state.statustw ? ic_keyboard_arrow_up : ic_keyboard_arrow_down} size={16} className="pull-right" onClick={(e) => { this.sortingFunc('okasBox_serialNo', '') }} /></th> */}
                                    <th style={{ width: this.props.windowWidth > 835 ? "15%" : "15%" }}>
                                        SERIAL NO.
                                        {this.state.statustw ? (
                                            <IoIosArrowUp size={16} className="pull-right" onClick={() => this.sortingFunc("okasBox_serialNo", "")} />
                                        ) : (
                                            <IoIosArrowDown size={16} className="pull-right" onClick={() => this.sortingFunc("okasBox_serialNo", "")} />
                                        )}
                                    </th>
                                    {/* <th style={{ width: this.props.windowWidth > 835 ? "20%" : "25%" }}>BOX VERSION<Icon icon={this.state.statusth ? ic_keyboard_arrow_up : ic_keyboard_arrow_down} size={16} className="pull-right" onClick={(e) => { this.sortingFunc('okasBox_version', '') }} /></th> */}
                                    <th style={{ width: this.props.windowWidth > 835 ? "20%" : "25%" }}>
                                        BOX VERSION
                                        {this.state.statusth ? (
                                            <IoIosArrowUp size={16} className="pull-right" onClick={() => this.sortingFunc("okasBox_version", "")} />
                                        ) : (
                                            <IoIosArrowDown size={16} className="pull-right" onClick={() => this.sortingFunc("okasBox_version", "")} />
                                        )}
                                    </th>
                                    {/* <th style={{ width: this.props.windowWidth > 835 ? "15%" : "15%" }}>STATUS<Icon icon={this.state.statusfo ? ic_keyboard_arrow_up : ic_keyboard_arrow_down} size={16} className="pull-right" onClick={(e) => { this.sortingFunc('user', '') }} /></th> */}
                                    <th style={{ width: this.props.windowWidth > 835 ? "15%" : "15%" }}>
                                        STATUS
                                        {this.state.statusfo ? (
                                            <IoIosArrowUp size={16} className="pull-right" onClick={() => this.sortingFunc("user", "")} />
                                        ) : (
                                            <IoIosArrowDown size={16} className="pull-right" onClick={() => this.sortingFunc("user", "")} />
                                        )}
                                    </th>
                                    {/* <th style={{ width: this.props.windowWidth > 835 ? "18%" : "10%" }}>DATE OF PURCHASE<Icon icon={this.state.statusfi ? ic_keyboard_arrow_up : ic_keyboard_arrow_down} size={16} className="pull-right" onClick={(e) => { this.sortingFunc('created_at', '') }} /></th> */}
                                    <th style={{ width: this.props.windowWidth > 835 ? "18%" : "10%" }}>
                                        DATE OF PURCHASE
                                        {this.state.statusfi ? (
                                            <IoIosArrowUp size={16} className="pull-right" onClick={() => this.sortingFunc("created_at", "")} />
                                        ) : (
                                            <IoIosArrowDown size={16} className="pull-right" onClick={() => this.sortingFunc("created_at", "")} />
                                        )}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.renderTableData('type1')}
                            </tbody>
                        </table>
                        <div className="pull-right">
                            {this.state.todosPerPage < this.state.okasInventoryData.length ?
                                <ul className="pagination pull-right paginat">

                                    <li>
                                        <span className="">Showing {(this.state.currentPage * this.state.todosPerPage) - this.state.todosPerPage + 1} -{this.state.currentPage * this.state.todosPerPage - this.state.okasInventoryData.length < 0 ? this.state.currentPage * this.state.todosPerPage : this.state.okasInventoryData.length}  of {this.state.okasInventoryData.length} enteries</span>
                                    </li>

                                    <li>
                                        <a
                                            onClick={this.state.currentPage == -1 + this.state.currentPage * this.state.todosPerPage ? null :
                                                this.handleClickpage.bind(this, this.state.currentPage - 1)
                                            }
                                            aria-label="Previous">
                                            <span aria-hidden="true">&laquo;</span>
                                            <span className="sr-only">Previous</span>
                                        </a>
                                    </li>

                                    {this.renderTableData('pagination')}
                                    <li className="">
                                        <a className=""
                                            onClick={this.state.currentPage * this.state.todosPerPage == this.state.okasInventoryData.length ? null :
                                                this.handleClickpage.bind(this, this.state.currentPage + 1)
                                            }

                                            aria-label="Next">
                                            <span aria-hidden="true">&raquo;</span>
                                            <span className="sr-only">Next</span>
                                        </a>
                                    </li>
                                </ul>
                                : null}
                        </div>

                    </div> </div>

            </div>
        </div>
        );
    }

}

const mapStateToProps = state => {
    return {
        redux: state,
    };
};


const mapDispatchToProps = dispatch => {
    return {
        searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
        searchBarStyleActivate: (data) => dispatch({ type: ActionTypes.SEARCHBARSTYLE, data: data }),
        backgroundScrollStop: (data) => dispatch({ type: ActionTypes.SCROLLSTOP, data: data }),

    };
};


// export default windowSize(connect(mapStateToProps, mapDispatchToProps)(AssignOkasBox)); 
export default connect(mapStateToProps, mapDispatchToProps)(AssignOkasBox); 